import React from "react";
import SupernovaOrb from "./SupernovaOrb";
import { supernovaMeta } from "../../config/supernovaMeta";

/**
 * One collection card: the token's artwork full-bleed, its name and lore over
 * the fade, and a footer holding whatever the caller knows about it.
 *
 * The art and the lore come from config/supernovaMeta — bundled locally, never
 * an IPFS request — and the fallback for a missing image is SupernovaOrb's, so
 * a card whose PNG failed still shows the token's own colours.
 *
 * THE CARD ASSERTS NOTHING. Every figure on it is passed in by a caller that
 * has actually read it; the walletless showcase passes a line of copy instead.
 * The staked pill only appears when a staked count is known AND non-zero — an
 * unread count draws no pill rather than a "0 staked" one.
 *
 * @param {Object} props
 * @param {number} props.tokenId
 * @param {string} props.name                the token's display name
 * @param {React.ReactNode} [props.pill]     top-right badge, e.g. "2 staked"
 * @param {React.ReactNode} [props.footer]   the counts line
 * @param {React.ReactNode} [props.action]   the Stake button
 */
const SupernovaCard = ({ tokenId, name, pill, footer, action }) => {
  const meta = supernovaMeta(tokenId);

  return (
    <div className="sn-card" data-testid="supernova-card">
      <div className="sn-card-inner">
        <div className="sn-art">
          {pill && <div className="sn-pill">{pill}</div>}
          {/* Decorative: the card's own heading names the token right below. */}
          <SupernovaOrb tokenId={tokenId} name={null} shape="cover" />
          <div className="sn-shine" aria-hidden="true" />
          <div className="sn-meta">
            <h4>{name}</h4>
            {meta && <p>{meta.description}</p>}
          </div>
        </div>
        {(footer || action) && (
          <div className="sn-own">
            {footer && <div className="min-w-0">{footer}</div>}
            {action}
          </div>
        )}
      </div>
    </div>
  );
};

export default SupernovaCard;
